import React from 'react';
import PropTypes from 'prop-types';


const PageTitle = ({ title, titleKey = 'title', t = (key) => key }) => {
  return (
    <h4 className="text-center section-header">{title ?? t(titleKey)}</h4>
  );
};

PageTitle.propTypes = {
  title: PropTypes.string,
  titleKey: PropTypes.string,
  t: PropTypes.func,
};

export default PageTitle;
